const paymentInstructions = {
  '002': {
    ATM: [
      'Masukkan kartu Anda dan PIN Anda',
      'Pilih menu Transaksi Lainnya',
      'Pilih Pembayaran',
      'Pilih Pembayaran lain-lain',
      'Pilih Virtual Account',
      'Masukkan Nomor Virtual Account, misal 8625XXXXXXXXXXXX',
      'Select Benar',
    ],
    'Mobile Banking': [
      'Buka aplikasi BRImo',
      'Login dengan akun Anda',
      'Pilih menu Pembayaran',
      'Pilih Virtual Account',
      'Masukkan nomor Virtual Account',
      'Selesaikan pembayaran',
    ],
    'Internet Banking': [
      'Masuk ke ib.bri.co.id',
      'Login dengan username dan password',
      'Pilih menu Pembayaran',
      'Pilih Virtual Account',
      'Masukkan nomor Virtual Account',
      'Konfirmasi dan bayar',
    ],
  },
  '014': {
    ATM: [
      'Masukkan kartu ATM dan PIN kamu',
      'Pilih Menu Transaksi Lainnya',
      'Pilih Transfer',
      'Pilih Ke rekening BCA Virtual Account',
      'Masukkan Nomor Virtual Account, (contoh: 123456789012XXXX)',
      'Pilih Benar',
      'Pilih Ya',
      'Ambil struk pembayaran kamu',
      'Pembayaran selesai',
    ],
    'Mobile Banking': [
      'Login Mobile Banking',
      'Pilih m-Transfer',
      'Pilih BCA Virtual Account',
      'Masukkan Nomor Virtual Account, (contoh: 123456789012XXXX) sebagai No. Virtual Account',
      'Klik Kirim',
      'Informasi Virtual Account akan ditampilkan',
      'Klik OK',
      'Masukkan PIN Mobile Banking',
      'Struk pembayaran ditampilkan',
      'Pembayaran selesai',
    ],
    'Internet Banking': [
      'Login Internet Banking',
      'Pilih Transaksi Dana',
      'Pilih Transfer Ke BCA Virtual Account',
      'Masukkan Nomor Virtual Account, (contoh: 123456789012XXXX) sebagai No. Virtual Account',
      'Klik Lanjutkan',
      'Masukkan Respon KeyBCA Appli 1',
      'Klik Kirim',
      'Struk pembayaran ditampilkan',
      'Pembayaran selesai',
    ],
  },
  '008': {
    ATM: [
      'Masukkan kartu ATM dan PIN kamu',
      'Pilih menu “Bayar / Beli”',
      'Pilih “Lainnya” 2x',
      'Pilih “Multi Payment”',
      'Masukkan (87827) sebagai Kode Perusahaan / Institusi',
      'Masukkan Nomor Virtual Account, (contoh 87827XXXXXXX) sebagai Nomor VA',
      'Pilih “Benar”',
      'Masukkan jumlah transfer sesuai dengan tagihan kamu. Jumlah yang berbeda tidak dapat diproses',
      'Pilih “Benar”',
      'Layar menampilkan Kode Bayar dan Data Pembayaran, lalu tekan “1” jika datanya benar',
      'Klik Ya untuk melakukan pembayaran',
      'Pembayaran selesai',
    ],
    'Mobile Banking': [
      'Masuk ke New Livin by Mandiri',
      'Pilih Menu Bayar',
      'Cari (87827) atau cari (LINKQU-BILL) sebagai Penyedia Jasa',
      'Masukkan Nomor Virtual Account, (contoh: 87827XXXXXXX)',
      'Pilih Lanjutkan',
      'Masukkan jumlah transfer sesuai dengan tagihan kamu. Jumlah yang berbeda tidak dapat diproses',
      'Layar menampilkan Kode Bayar dan Data Pembayaran',
      'Jika datanya benar, Klik Lanjutkan',
      'Masukkan PIN New Livin, Klik OK',
      'Pembayaran selesai',
    ],
    'Internet Banking': [
      'Masuk ke Internet Banking',
      'Pilih Bayar',
      'Pilih Multi Payment',
      'Cari (LINKQU-BILL) sebagai Penyedia Jasa',
      'Masukkan Nomor Virtual Account, misalnya (contoh: 87827XXXXXXX)',
      'Klik Lanjutkan',
      'Masukkan jumlah transfer sesuai dengan tagihan kamu. Jumlah yang berbeda tidak dapat diproses',
      'Centang IDR',
      'Klik Lanjutkan',
      'Masukkan Kode dari Token Mandiri, lalu klik Kirim',
      'Tampilan struk pembayaran',
      'Pembayaran selesai',
    ],
  },
  '009': {
    ATM: [
      'Masukkan Kartu kamu',
      'Pilih Bahasa',
      'Masukkan PIN ATM kamu',
      'Pilih “Menu Lainnya”',
      'Pilih “Transfer”',
      'Pilih jenis akun yang kamu gunakan (contoh; “Dari Rekening Tabungan”)',
      'Pilih “Virtual Account Billing”',
      'Masukkan Nomor Virtual Account kamu (contoh: 123456789012XXXX)',
      'Tagihan yang harus dibayar akan muncul di layar konfirmasi',
      'Konfirmasi, jika sesuai, lanjutkan transaksi',
      'Transaksi kamu telah selesai',
    ],
    'Mobile Banking': [
      'Akses BNI Mobile Banking dari ponsel kamu dan masukkan ID pengguna dan kata sandi',
      'Pilih menu “Transfer”',
      'Pilih menu “Virtual Account Billing” lalu pilih akun debit',
      'Masukkan Nomor Virtual Account kamu (contoh: 123456789012XXXX) pada menu “input baru”',
      'Tagihan yang harus dibayar akan muncul di layar konfirmasi',
      'Konfirmasi transaksi dan masukkan Kata Sandi Transaksi',
      'Pembayaran kamu Berhasil',
    ],
    'Internet Banking': [
      'Ketik alamat https://ibank.bni.co.id lalu klik “Enter”',
      'Masukkan ID Pengguna dan Kata Sandi',
      'Pilih menu “Transfer”',
      'Pilih “Virtual Account Billing”',
      'Kemudian masukkan Nomor Virtual Account kamu (contoh: 123456789012XXXX) yang akan dibayar. Kemudian pilih akun debit yang akan digunakan. Lalu tekan ‘’lanjut’’',
      'Kemudian tagihan yang harus dibayar akan muncul di layar konfirmasi',
      'Masukkan Kode Otentikasi Token',
      'Pembayaran kamu Berhasil',
    ],
  },
  490: {
    'Mobile Banking': [
      'Login ke neobank',
      'Pilih “VA Payment”',
      'Pilih “BNC” sebagai nama bank penerima',
      'Masukkan kode VA',
      'Masukkan jumlah pembayaran',
      'Konfirmasi informasi pembayaran',
      'Masukkan PIN kamu',
      'Transaksi selesai',
    ],
    'Internet Banking': [
      'Login ke neobank',
      'Pilih “VA Payment”',
      'Pilih “BNC” sebagai nama bank penerima',
      'Masukkan kode VA',
      'Masukkan jumlah pembayaran',
      'Konfirmasi informasi pembayaran',
      'Masukkan PIN kamu',
      'Transaksi selesai',
    ],
  },
  451: {
    ATM: [
      'Masukkan kartu ATM dan PIN kamu',
      'Pilih “Bayar / Beli”',
      'Pilih “Lainnya”',
      'Pilih “Bank Transfer”',
      'Pilih BSI Bank (451)',
      'Masukkan kode (9001062) + Nomor Virtual Account, (contoh: 900106xxxxxxxxxx)',
      'Masukkan jumlah transfer sesuai dengan tagihan kamu. Jumlah yang berbeda tidak bisa diproses',
      'Lakukan Pembayaran',
    ],
    'Mobile Banking': [
      'Pilih Menu Bayar dan Beli',
      'Pilih Lembaga',
      'Masukkan Kode LinkQu (1062)',
      'Masukkan Nomor Bayar',
      'Klik Check bill',
      'Masukkan PIN',
      'Selesai',
    ],
  },
  '022': {
    ATM: [
      'Masukkan kartu ATM dan PIN kamu',
      'Pilih Menu Pembayaran',
      'Pilih Menu Lanjut',
      'Pilih Menu Virtual Account',
      'Masukkan Nomor Virtual Account, (contoh: 5919XXXXXXXXXXXX)',
      'Pilih Proses',
      'Data Virtual Account akan ditampilkan',
      'Pilih Proses',
      'Ambil bukti pembayaran kamu',
      'Pembayaran selesai',
    ],
    'Mobile Banking': [
      'Login ke OCTO Mobile',
      'Pilih Menu Transfer',
      'Pilih Menu Other CIMB Niaga',
      'Pilih Sumber Akun',
      'Masukkan Nomor Virtual Account, (contoh: 5919XXXXXXXXXXXX)',
      'Klik Kirim',
      'Data Virtual Account akan ditampilkan',
      'Masukkan PIN Mobile',
      'Klik Konfirmasi',
      'Bukti pembayaran akan ditampilkan',
      'Pembayaran selesai',
    ],
    'Internet Banking': [
      'Login ke Internet Banking',
      'Pilih Pay Bills',
      'Source Account – Pilih akun yang ingin kamu gunakan',
      'Payment Type – Pilih Virtual Account',
      'Payment To – Pilih Masukkan Nomor Virtual Account',
      'Masukkan Nomor VA, (contoh: 5919XXXXXXXXXXXX)',
      'Klik Lanjut',
      'Data Virtual Account akan ditampilkan',
      'Masukkan mPIN',
      'Klik Kirim',
      'Bukti pembayaran akan ditampilkan',
      'Pembayaran selesai',
    ],
  },
  '011': {
    ATM: [
      'Masukkan PIN ATM kamu',
      'Pilih Menu Pembayaran >>> Virtual Account',
      'Masukkan Nomor Virtual Account',
      'Di layar konfirmasi pembayaran, pastikan transaksi benar -> pilih “Ya” untuk proses transaksi',
    ],
    'Mobile Banking': [
      'Login Aplikasi D-Mobile',
      'Pilih menu Virtual Account',
      'Masukkan 16 digit Nomor Virtual Account',
      'Di layar konfirmasi pembayaran, pastikan transaksi benar -> pilih “Ya” untuk proses transaksi',
    ],
  },
  '013': {
    ATM: [
      'Di menu utama, pilih Transaksi Lainnya',
      'Pilih menu Pembayaran',
      'Pilih Pembayaran Lainnya',
      'Pilih Virtual Account',
      'Masukkan Nomor Virtual Account (contoh: 7136XXXXXXXXXX)',
      'Jumlah yang harus dibayar dan nomor rekening akan muncul di halaman konfirmasi, jika informasi benar, pilih Benar.',
    ],
    'Mobile Banking': [
      'Buka aplikasi Permata Mobile X',
      'Masukkan Kata Sandi',
      'Pilih Bayar Tagihan',
      'Pilih Virtual Account',
      'Masukkan Nomor Virtual Account (contoh: 7136XXXXXXXXXX)',
      'Pilih Akun',
      'Masukkan jumlah pembayaran',
      'Konfirmasi pembayaran muncul',
      'Masukkan PIN Mobile',
      'Transaksi selesai.',
    ],
    'Internet Banking': [
      'Kunjungi situs web PermataNet',
      'Masukkan ID Pengguna dan Kata Sandi',
      'Pilih Pembayaran Tagihan',
      'Pilih Virtual Account',
      'Masukkan kode pembayaran 16 digit (contoh: 7136XXXXXXXXXX)',
      'Masukkan jumlah pembayaran',
      'Konfirmasi pembayaran muncul',
      'Masukkan PIN Mobile',
      'Transaksi selesai',
    ],
  },
  '016': {
    ATM: [
      'Masukkan PIN ATM Anda.',
      'Pilih Menu Transfer.',
      'Pilih Menu Virtual Account.',
      'Input Nomor Virtual Account, misal. 7800012345678901.',
      'Pilih Benar.',
      'Pilih Ya.',
      'Transaksi Selesai.',
    ],
    'Mobile Banking': [
      'Login Aplikasi M2U Menggunakan Fingerprint atau Masukkan Password.',
      'Pilih Transfer.',
      'Pilih Virtual Account.',
      'Pilih Sumber Tabungan.',
      'Masukkan Nomor Virtual Account (7800012345678901), klik Lanjut.',
      'Masukkan Jumlah Transfer, klik Proses.',
      'Klik Konfirmasi & Minta TAC.',
      'Masukkan SMS Token/TAC.',
      'Klik OK.',
      'Transaksi Selesai.',
    ],
    'Internet Banking': [
      'Login Internet Banking.',
      'Pilih Rekening dan Transaksi.',
      'Pilih Maybank Virtual Account.',
      'Pilih Sumber Tabungan.',
      'Input Nomor Virtual Account, misal. 7800012345678901.',
      'Input Nominal, misal. 10000.',
      'Klik Submit.',
      'Input SMS Token.',
      'Bukti bayar ditampilkan.',
      'Transaksi Selesai.',
    ],
  },
  '028': {
    ATM: [
      'Masukkan Kartu (ATM).',
      'Pilih menu Transfer Antar Bank.',
      'Pilih Bank OCBC NISP dan masukkan nomor Virtual Account dan nominal pembayaran Anda.',
      'Periksa kembali pembayaran Virtual Account Anda.',
      'Klik Bayar, Selesai.',
    ],
    'Mobile Banking': [
      'Buka dan login OCBC mobile.',
      'Pilih menu “Pay & Purchase”.',
      'Pilih “Other Payment”.',
      'Pilih kategori “LINK QU”.',
      'Masukkan Nomor Virtual Account (Customer ID) dan nominal transfer.',
      'Periksa detail transaksi dan klik “Continue”.',
      'Masukkan PIN Transaksi.',
    ],
    'Internet Banking': [
      'Login ke account anda.',
      'Pilih menu Transfer Antar Bank.',
      'Pilih Bank OCBC NISP dan masukkan nomor Virtual Account dan nominal pembayaran Anda.',
      'Periksa kembali pembayaran Virtual Account Anda.',
      'Klik Bayar, Selesai.',
    ],
  },
  147: {
    ATM: [
      'Masukkan kartu ATM, lalu input PIN Anda.',
      'Pilih Menu “TRANSAKSI LAIN”.',
      'Pilih menu “PEMBAYARAN” kemudian pilih menu “VIRTUAL ACCOUNT”.',
      'Masukkan Nomor Virtual Account.',
      'Tekan “BAYAR” jika setuju dengan informasi pembayaran.',
      'Periksa kembali Jumlah Tagihan.',
      'Apabila sudah sesuai, tekan “BENAR”, lalu tekan “BAYAR”.',
      'Simpan struk ATM sebagai bukti pembayaran.',
    ],
    'Mobile Banking': [
      'Login ke Mobile Banking Muamalat.',
      'Pilih menu “PEMBAYARAN”.',
      'Masukkan Nomor Virtual Account, klik “PROSES”.',
      'Periksa kembali Jumlah Pembayaran, klik “BAYAR”.',
      'Transaksi Anda selesai. Simpan struk sebagai bukti transaksi.',
    ],
    'Internet Banking': [
      'Login ke akun Anda.',
      'Pilih menu “Transfer Antar Bank”.',
      'Pilih Bank Muamalat dan masukkan nomor Virtual Account dan nominal pembayaran Anda.',
      'Periksa kembali pembayaran Virtual Account Anda.',
      'Klik “BAYAR”, Selesai.',
    ],
  },
  153: {
    ATM: [
      'Masukkan kartu ATM dan input PIN Anda.',
      'Pilih menu “TRANSFER”.',
      'Pilih “Rekening Bank Sinarmas” atau “Rekening Nasabah Lain”.',
      'Masukkan nomor rekening tujuan dan jumlah transfer.',
      'Masukkan nomor referensi dan periksa layar konfirmasi.',
      'Jika data sudah benar, pilih “YA”.',
    ],
    'Internet Banking': [
      'Login ke Internet Banking Bank Sinarmas.',
      'Pilih menu “TRANSFER”.',
      'Masukkan nomor rekening tujuan: 8005XXXXXXXXXXXX.',
      'Nama pemegang rekening: ASM QQ ABCD (nama pengirim).',
      'Masukkan nominal sesuai dengan jumlah pada kwitansi.',
    ],
  },
}

export default paymentInstructions
